module.exports = __webpack_public_path__ + "media/images/crm/content-illustration-1-a4767f525bcc0d57f92149010554229b.png";